import { ThemeProps, IconText, MediaQueries } from '@hhgtech/hhg-components'
import { Popup } from 'components/molecules/popup'
import { Z_INDEX } from 'interfaces/constants'
import styled, { StyledComponent } from 'styled-components'

export const StyledLikeWrapper: StyledComponent<
  'div',
  any,
  { on?: string },
  never
> = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${MediaQueries.mbUp} {
    margin-bottom: 1rem;
  }

  img {
    width: 24px;
    height: 24px;
  }
`

export const StyledIconWrapper: StyledComponent<
  'div',
  any,
  { on?: string },
  never
> = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${MediaQueries.mbUp} {
    margin-bottom: 1rem;
  }
  > a svg {
    cursor: pointer;
  }
  > svg {
    cursor: pointer;
  }

  > a img,
  > img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .gray-facebook-svg {
    path:first-child {
      fill: ${(props: ThemeProps) => props.theme.colors.gray500};
    }
  }
  &[data-disabled='true'] {
    cursor: none;
    opacity: 0.6;
    pointer-events: none;
  }
  .icon-number {
    ${MediaQueries.mbDown} {
      padding-left: 4px;
    }
    color: ${(props: ThemeProps) => props.theme.colors.gray600};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
  a {
    &[data-event-category='FeedbackIcon'] {
      cursor: pointer;

      div > span {
        top: 30%;
        left: 50%;
        background-color: ${(props: ThemeProps) =>
          props.theme.colors.primaryBase};
        color: white;
      }

      svg {
        width: 24px;
        height: 24px;
      }
    }
  }

  &[data-type-icon='comment'] {
    div > span {
      top: 30%;
      left: 50%;
      background-color: ${(props: ThemeProps) =>
        props.theme.colors.primaryBase};
      color: white;
      cursor: pointer;
    }

    svg {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
  &[data-empty-comment='true'] {
    div > span {
      background-color: ${(props: ThemeProps) => props.theme.colors.green300};
    }
  }

  .comment-count {
    position: absolute;
    top: -4px;
    right: -4px;
    font-size: 10px;
    width: 14px;
    height: 14px;
    color: white;
    border-radius: 50%;
    line-height: 14px;
    text-align: center;
    background-color: ${(props: ThemeProps) => props.theme.mbColors.pink};
  }

  .empty-comment {
    position: absolute;
    top: 0px;
    right: -2px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: red;
  }

  .comment-with-badge {
    > div:first-child span {
      top: -6px !important;
      right: -9px;
      left: unset;
      min-width: 18px;
      height: unset;
      padding: 4px 2px;
      background-color: ${(props: ThemeProps) => props.theme.mbColors.pink};
      border-radius: 50%;
      font-size: 10px;
    }
  }
`
export const StyledArticleBottomBar = styled.div`
  position: fixed;
  z-index: 50;
  bottom: 16px;
  left: 16px;
  display: flex;
  width: calc(100% - 32px);
  justify-content: space-between;
  padding: 1rem;
  background: rgba(256, 256, 256, 0.98);

  border-radius: 16px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);

  padding-bottom: 1rem;

  // make sure that the bottom bar is not overlapped by the home indicator on newer iPhones
  @supports (margin-bottom: env(safe-area-inset-bottom)) {
    margin-bottom: env(safe-area-inset-bottom);
    bottom: calc(16px - env(safe-area-inset-bottom));
  }

  ${MediaQueries.mbUp} {
    position: sticky;
    top: min(6rem, 100vh / 4);
    bottom: unset;
    left: unset;
    width: 57px;
    margin-left: calc(-90px + 1rem);
    @supports (margin-left: env(safe-area-inset-left)) {
      padding-left: max(env(safe-area-inset-left), 1rem);
    }
    flex-direction: column;
    justify-content: space-between;
    height: min(300px, 100vh / 1.5);
  }

  ${StyledIconWrapper}:last-child {
  }
`

export const StyledProgress = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 3px;
  background-color: ${(props: ThemeProps) => props.theme.colors.primaryBase};
  transition: width 150ms linear;
  ${MediaQueries.mbUp} {
    display: none;
  }
`
export const StyledIconText = styled(IconText)`
  &[data-icon-position='left'] > *:first-child {
    margin-right: 0;
  }
`

export const StyledFontSetting = styled.div`
  position: relative;
  cursor: pointer;

  > svg {
    cursor: pointer;
  }

  .background {
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: ${(props: ThemeProps) => props.theme.mbColors.dark};
    opacity: 0.65;
  }

  .content {
    position: absolute;
    z-index: ${Z_INDEX.adBlock};
    top: -160%;
    left: 3rem;
    width: 344px;
    padding: 24px 16px;
    background-color: ${(props: ThemeProps) => props.theme.colors.white};
    border-radius: 16px;

    &:before {
      position: absolute;
      /* z-index: ${Z_INDEX.adBlock}; */
      bottom: 50%;
      left: -12px;
      display: block;
      width: 0;
      height: 0;
      border-width: 6px;
      border-style: solid;
      border-color: transparent
        ${(props: ThemeProps) => props.theme.colors.white} transparent
        transparent;
      content: '';
    }
  }
`

export const StyledPopup = styled(Popup)`
  &#font-setting-popup {
    overflow: hidden;
    height: fit-content;
    border-radius: 16px 16px 0 0;

    .header {
      padding: 16px;
      background-color: ${(props: ThemeProps) =>
        props.theme.mbColors.lightGray};
      border-radius: 16px 16px 0 0;
    }

    .font-setting__wrapper {
      padding: 16px 24px;
    }

    .close-button {
      top: 16px;
      right: 16px;
      width: 24px;
      height: 24px;
    }
  }
`
